import Icon from "../../../Icons/services/Icon";

const EstadoItem = ({ color, label, value }) => {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2.5">
        <span className={`h-3 w-3 shrink-0 rounded-full ${color}`} />

        <span className="truncate text-sm font-medium text-slate-500">
          {label}
        </span>
      </div>

      <span className="text-sm font-semibold text-slate-800">
        {value ?? 0}
      </span>
    </div>
  );
};

//----------------------------------------------------------------------------------------------------------------------
export default function CardService({prefijo, icon, nombre, area, atendidos = 0, porAtender = 0, pendientes = 0, enProceso = 0, iconColor = "text-sidebar", iconBg = "bg-sidebar/10",}) 
{
  const total =
    Number(atendidos) +
    Number(porAtender) +
    Number(pendientes) +
    Number(enProceso);

  const porcentajeAtendidos =
    total > 0
      ? Math.round((Number(atendidos) / total) * 100)
      : 0;

  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_8px_24px_rgba(15,23,42,0.07)] transition-all
                        duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_32px_rgba(15,23,42,0.10)]">
      {/* Encabezado */}
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="truncate text-base font-semibold text-slate-800">
            {nombre}
          </h3>
          <p className="mt-2 text-sm font-medium text-slate-500">
            Total: {total} turnos
          </p>
        </div>

        <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${iconBg}`}>
          <div className={`h-6 w-6 ${iconColor} [&_svg]:h-full [&_svg]:w-full [&_svg]:fill-current [&_svg]:stroke-current`}>
            {icon ? (<Icon svg={icon} className="h-full w-full shrink-0 fill-sidebar"/>):
            (                  
              <span className="text-[0.95rem] lg:text-[1.5rem] font-bold text-sidebar leading-none">
                 prefijo
              </span>
            )}
            
          </div>
        </div>
      </div>

      <div className="my-4 h-px bg-slate-100" />

      {/* Estados */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <EstadoItem
          color="bg-atendido"
          label="Atendidos"
          value={atendidos}
        />

        <EstadoItem
          color="bg-poratender"
          label="Por atender"
          value={porAtender}
        />

        <EstadoItem
          color="bg-pendiente"
          label="Pendientes"
          value={pendientes}
        />

        <EstadoItem
          color="bg-enproceso"
          label="En proceso"
          value={enProceso}
        />
      </div>

      {/* Progreso */}
      <div className="mt-5">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-medium text-slate-400">
            Atenciones completadas
          </span>

          <span className="text-xs font-semibold text-slate-600">
            {porcentajeAtendidos}%
          </span>
        </div>

        <div className="h-2 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full bg-atendido transition-all duration-500"
            style={{ width: `${porcentajeAtendidos}%` }}
          />
        </div>
      </div>
    </article>
  );
}